import React, { Component } from 'react'
// Custom Module
import request from "../../../lib/requester";
import Autocomplete from '../../../component/autocomplete/custom';

// Downloaded Module
import _ from "lodash";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";

class DetailRecommendation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ACTIVE_FLAG: "",
      ADDRESS_OUTLET_SUBDIST: "",
      ADDRESS_OUTLET_AAM: "",
      BRANCH_DESC_SUBDIST: "",
      BRANCH_DESC_AAM: "",
      BRANCH_RAYON: "",
      CHANNEL: "",
      CHANNEL_OTC: "",
      CITY: "",
      FLAG_CUSTOMER: "",
      FLAG_MAPPING_OUTLET: "",
      FLAG_MAPPING_RAYON: "",
      GROUP_MODERN: "",
      OUTLET_CODE_AAM: "",
      OUTLET_CODE_SUBDIST: "",
      OUTLET_ID_AAM: "",
      OUTLET_ID_SUBDIST: "",
      OUTLET_NAME_AAM: "",
      OUTLET_NAME_SUBDIST: "",
      MATCH_PCT: 0,
      PILAR: "",
      RAYON: "",
      ROW_CURRENT_FLAG: "",
      SUBDIST_ID: "",
      SUBDIST_NAME: "",
      lovPilar: [],
      lovChannel: [],
      lovRayon: [],
      lovBranch: [],
      error: [],
      success: '',
      user: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.getLov()
  }

  getLov = () => {
    let url = '/api/traces_chd/v1/recommendation/data-lov'
    let param = {}

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let { data } = response.data
        this.setState({
          lovChannel: data.channel,
          lovPilar: data.pilar,
          lovRayon: data.rayon,
          lovBranch: data.branch
        })
        this.getDetail()
      }.bind(this),
      error: function(e) {
        console.log(e.message)
      }.bind(this)
    })
  }

  getDetail = () => {
    let { id } = this.props.match.params
    let url = '/api/traces_chd/v1/recommendation/detail-approval'
    let param = {
      ID: id
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let { data } = response.data
        this.setState({ loading: false })
        this.setDefaultGeneral(data)
      }.bind(this),
      error: function(e) {
        console.log(e.message)
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  setDefaultGeneral = (data) => {
    this.setState({
      ACTIVE_FLAG: data.ACTIVE_FLAG,
      ADDRESS_OUTLET_AAM: data.ADDRESS_OUTLET_AAM,
      ADDRESS_OUTLET_SUBDIST: data.ADDRESS_OUTLET_SUBDIST,
      BRANCH_DESC_SUBDIST: data.BRANCH_DESC_SUBDIST,
      BRANCH_RAYON: data.BRANCH_RAYON,
      BRANCH_DESC_AAM: data.BRANCH_DESC_AAM ? data.BRANCH_DESC_AAM : data.BRANCH_DESC ? data.BRANCH_DESC : '',
      CHANNEL: data.CHANNEL,
      CHANNEL_OTC: data.CHANNEL_OTC,
      CITY: data.CITY,
      FLAG_CUSTOMER: data.FLAG_CUSTOMER,
      FLAG_MAPPING_OUTLET: data.FLAG_MAPPING_OUTLET,
      FLAG_MAPPING_RAYON: data.FLAG_MAPPING_RAYON,
      GROUP_MODERN: data.GROUP_MODERN,
      MATCH_PCT: data.MATCH_PCT || 0,
      OUTLET_CODE_AAM: data.OUTLET_CODE_AAM,
      OUTLET_CODE_SUBDIST: data.OUTLET_CODE_SUBDIST,
      OUTLET_ID_AAM: data.OUTLET_ID_AAM,
      OUTLET_ID_SUBDIST: data.OUTLET_ID_SUBDIST,
      OUTLET_NAME_AAM: data.OUTLET_NAME_AAM,
      OUTLET_NAME_SUBDIST: data.OUTLET_NAME_SUBDIST,
      PILAR: data.PILAR,
      RAYON: data.RAYON,
      ROW_CURRENT_FLAG: data.ROW_CURRENT_FLAG,
      SUBDIST_ID: data.SUBDIST_ID,
      SUBDIST_NAME: data.SUBDIST_NAME,
    })

    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }
  
  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  formSubdist = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <b>SUBDIST</b>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample3">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4">Outlet ID Subdist</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.OUTLET_ID_SUBDIST} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Outlet Code Subdist</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.OUTLET_CODE_SUBDIST} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Outlet Name Subdist</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.OUTLET_NAME_SUBDIST} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Address Outlet Subdist</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.ADDRESS_OUTLET_SUBDIST} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4">Subdist ID</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.SUBDIST_ID} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Subdist Name</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.SUBDIST_NAME} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Channel</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.CHANNEL} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">City</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.CITY} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  handleChangeChannel = (e) => {
    let value = e.target.value
    this.setState({ CHANNEL_OTC: value })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  handleChangeRayon = (e) => {
    let value = e.target.value
    this.setState({ RAYON: value })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  handleChangePilar = (e) => {
    let value = e.target.value
    this.setState({ PILAR: value})
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  handleChangeBranch = (e) => {
    let value = e.target.value
    this.setState({ BRANCH_DESC_AAM: value })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  onChangeAutocomplete = (type, description) => {
    let container = [];
    let param = {
      query: description,
      type: type
    };

    if (type === 'GROUP_MODERN') {
      this.setState({ GROUP_MODERN: description })
    }
    
    return new Promise((resolve, reject) => {
      if (description.length > 3) {
        request.postCHD("/api/traces_chd/v1/recommendation/detail-outlet", param, {
          success: function (response) {
            var api_response = response.data.data;
            container = api_response.map((item, index) => {
              if (type === 'OUTLET_NAME') {
                item.text = item.OUTLET_NAME_AAM;
                item.value = item.OUTLET_NAME_AAM;
              } else if (type == 'OUTLET_ID') {
                item.text = item.OUTLET_ID_AAM;
                item.value = item.OUTLET_ID_AAM;
              } else if (type == 'OUTLET_CODE') {
                item.text = item.OUTLET_CODE_AAM;
                item.value = item.OUTLET_CODE_AAM;
              } else if (type === 'GROUP_MODERN') {
                item.text = item.GROUP_MODERN;
                item.value = item.GROUP_MODERN;
              }
              
              return item;
            });
            resolve(container);
          },
          error: function (e) {
            resolve([]);
          },
        });
      } else {
        reject([])
        if (type === 'OUTLET_NAME') {
          this.setState({ OUTLET_NAME_AAM: description })
        } else if (type == 'OUTLET_ID') {
          this.setState({ OUTLET_ID_AAM: description })
        } else if (type == 'OUTLET_CODE') {
          this.setState({ OUTLET_CODE_AAM: description })
        } else if (type === 'GROUP_MODERN') {
          this.setState({ GROUP_MODERN: description })
        }
        this.setElement()
      }
    });
  };

  onChangeAutocompleteRayon = (description) => {
    let container = [];
    let param = {
      query: description
    };

    return new Promise((resolve) => {
      request.postCHD("/api/traces_chd/v1/recommendation/search-rayon", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.RAYON_ID
            item.value = item.RAYON_ID
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  }

  onSelectRayon = (item) => {
    this.setState({ RAYON: item.RAYON_ID, BRANCH_RAYON: item.BRANCH_RAYON })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  onSelectOutleName = (item, index) => {
    this.setState({
      OUTLET_ID_AAM: item.OUTLET_ID_AAM,
      OUTLET_CODE_AAM: item.OUTLET_CODE_AAM,
      OUTLET_NAME_AAM: item.OUTLET_NAME_AAM,
      GROUP_MODERN: item.GROUP_MODERN,
      ADDRESS_OUTLET_AAM: item.ADDRESS_OUTLET_AAM
    })

    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  };

  setElement = () => {
    let {OUTLET_ID_AAM, OUTLET_NAME_AAM, OUTLET_CODE_AAM, GROUP_MODERN, RAYON } = this.state
    document.getElementById('OUTLET_ID').value = OUTLET_ID_AAM
    document.getElementById('OUTLET_CODE').value = OUTLET_CODE_AAM
    document.getElementById('OUTLET_NAME').value = OUTLET_NAME_AAM
    document.getElementById('GROUP_MODERN').value = GROUP_MODERN
    document.getElementById('RAYON').value = RAYON
  }

  onSelectOutletCode = (item) => {
    this.setState({ OUTLET_CODE_AAM: item.OUTLET_CODE_AAM })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  onSelectOutletId = (item) => {
    this.setState({ OUTLET_ID_AAM: item.OUTLET_ID_AAM })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  onSelectOutletGroup = (item) => {
    this.setState({ GROUP_MODERN: item.GROUP_MODERN })
    let app = this
    window.setTimeout(() => {
      app.setElement()
    }, 200)
  }

  formRecommendation = () => {
    let app = this
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light"><b>AAM</b></div>
            <div className="multi-collapse show" id="multiCollapseExample3">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4">Outlet Name AAM</label>
                      <Autocomplete id="OUTLET_NAME" className="form-control col-md-8" onchange={this.onChangeAutocomplete.bind(this, 'OUTLET_NAME')} onselect={this.onSelectOutleName.bind(this)} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Outlet ID AAM</label>
                      <Autocomplete id="OUTLET_ID" className="form-control col-md-8" onchange={this.onChangeAutocomplete.bind(this, 'OUTLET_ID')} onselect={this.onSelectOutletId.bind(this)} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Outlet Code AAM</label>
                      <Autocomplete id="OUTLET_CODE" className="form-control col-md-8" onchange={this.onChangeAutocomplete.bind(this, 'OUTLET_CODE')} onselect={this.onSelectOutletCode.bind(this)} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Group Modern</label>
                      <Autocomplete id="GROUP_MODERN" className="form-control col-md-8" onchange={this.onChangeAutocomplete.bind(this, 'GROUP_MODERN')} onselect={this.onSelectOutletGroup.bind(this)} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4">Rayon</label>
                      <Autocomplete id="RAYON" className="form-control col-md-8" onchange={this.onChangeAutocompleteRayon.bind(this)} onselect={this.onSelectRayon.bind(this)} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Branch Rayon</label>
                      <input type="text" className="form-control col-md-8" value={this.state.BRANCH_RAYON} disabled={true} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Channel</label>
                      <select className="form-control col-md-8" value={this.state.CHANNEL_OTC} onChange={this.handleChangeChannel.bind(this)}>
                        <option value={''}>- Select Channel -</option>
                        {
                          this.state.lovChannel.map((item) => (
                            <option value={item.CHANNEL_OTC_DESC}>{item.CHANNEL_OTC_DESC}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Pilar</label>
                      <select className="form-control col-md-8" value={this.state.PILAR} onChange={this.handleChangePilar.bind(this)}>
                        <option value={''}>- Select Pilar -</option>
                        {
                          this.state.lovPilar.map((item) => (
                            <option value={item.PILAR}>{item.PILAR}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Branch</label>
                      <select className="form-control col-md-8" value={this.state.BRANCH_DESC_AAM} onChange={this.handleChangeBranch.bind(this)}>
                        <option value={''}>- Select Branch -</option>
                        {
                          this.state.lovBranch.map((item) => (
                            <option value={item.org_name}>{item.org_name}</option>
                          ))
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4">Flag Customer</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.FLAG_CUSTOMER} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Flag Mapping Outlet</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.FLAG_MAPPING_OUTLET} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Flag Mapping Rayon</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.FLAG_MAPPING_RAYON} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4">Address Outlet AAM</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.ADDRESS_OUTLET_AAM} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4">Match Percentage</label>
                      <div className="col-md-8">
                        <h1 className={this.state.matchColor}>{ this.state.MATCH_PCT} %</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleSubmit = () => {
    let { user } = this.state
    let url = '/api/traces_chd/v1/recommendation/insert'
    let param = {
      ACTIVE_FLAG: this.state.ACTIVE_FLAG,
      ADDRESS_OUTLET_AAM: this.state.ADDRESS_OUTLET_AAM,
      ADDRESS_OUTLET_SUBDIST: this.state.ADDRESS_OUTLET_SUBDIST,
      BRANCH_DESC_SUBDIST: this.state.BRANCH_DESC_SUBDIST,
      BRANCH_DESC_AAM: this.state.BRANCH_DESC_AAM,
      BRANCH_RAYON: this.state.BRANCH_RAYON,
      CHANNEL: this.state.CHANNEL,
      CHANNEL_OTC: this.state.CHANNEL_OTC,
      CITY: this.state.CITY,
      FLAG_CUSTOMER: this.state.FLAG_CUSTOMER,
      FLAG_MAPPING_OUTLET: this.state.FLAG_MAPPING_OUTLET,
      FLAG_MAPPING_RAYON: this.state.FLAG_MAPPING_RAYON,
      GROUP_MODERN: this.state.GROUP_MODERN,
      MATCH_PCT: this.state.MATCH_PCT,
      OUTLET_CODE_AAM: this.state.OUTLET_CODE_AAM,
      OUTLET_CODE_SUBDIST: this.state.OUTLET_CODE_SUBDIST,
      OUTLET_ID_AAM: this.state.OUTLET_ID_AAM,
      OUTLET_ID_SUBDIST: this.state.OUTLET_ID_SUBDIST,
      OUTLET_NAME_AAM: this.state.OUTLET_NAME_AAM,
      OUTLET_NAME_SUBDIST: this.state.OUTLET_NAME_SUBDIST,
      PILAR: this.state.PILAR,
      RAYON: this.state.RAYON,
      ROW_CURRENT_FLAG: this.state.ROW_CURRENT_FLAG,
      SUBDIST_ID: this.state.SUBDIST_ID,
      SUBDIST_NAME: this.state.SUBDIST_NAME,
      STATUS: 'A',
      USERNAME: user.username
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let { data, message } = response.data
        this.setState({
          loading: false,
          success: message
        })

        let app = this
        window.scrollTo(0,0)
        window.setTimeout(() => {
          app.props.history.push('/admin/recommendation-chd/list-approval')
        }, 3000)
      }.bind(this),
      error: function(e) {
        let msg = e.response.data
        this.setState({
          loading: false,
          error: [msg.message || 'Failed to request API']
        })
      }.bind(this)
    })
  }

  handleCancel = () => {
    this.props.history.push('/admin/recommendation-chd/list-approval')
  }

  renderButton = () => {
    return (
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-3">
          <button className="btn btn-success btn-block" type="button" onClick={this.handleSubmit.bind(this)}><i className="fa fa-check"></i> Approve</button>
        </div>
        <div className="col-md-3">
          <button className="btn btn-danger btn-block" onClick={this.handleCancel.bind(this)}><i className="fa fa-timse"></i> Cancel</button>
        </div>
        <div className="col-md-3"></div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-body">
                    { this.showNotification() }
                    { this.formSubdist() }
                    { this.formRecommendation() }
                    { this.renderButton() }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
          <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default DetailRecommendation